// Seleccionamos todos los elementos con la clase 'toggle'
document.querySelectorAll('.toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function(event) {
        event.preventDefault(); // Prevenir el comportamiento por defecto del enlace
        this.classList.toggle('active'); // Alternar la clase 'active'
        
        // Buscar la sub-lista asociada y alternar su visibilidad
        let subList = this.nextElementSibling;
        if (subList.style.display === "block") {
            subList.style.display = "none";
        } else {
            subList.style.display = "block";
        }
    });

});

    let selectedWaist = null;
    let selectedInseam = null;

    // Función para seleccionar la variante basada en waist y inseam
    function selectVariant() {
        if (selectedWaist && selectedInseam) {
            const variantValue = `${selectedWaist}/${selectedInseam}`;
            const variantInput = document.querySelector(`input[type="radio"][value="${variantValue}"]`);
            
            if (variantInput) {
                variantInput.click();
                variantInput.checked = true;
                console.log('Variant found:', variantValue);
            } else {
                console.log('Variant not found:', variantValue);
            }
        }
    }


    // Function to update the availability of inseam options based on the selected waist
    function updateInseamOptions() {
        const inseamItems = document.querySelectorAll('.sub-list.inseam li');
        inseamItems.forEach(item => {
            const inseamValue = item.getAttribute('data-inseam');
            const variantValue = `${selectedWaist}/${inseamValue}`;
            const variantInput = document.querySelector(`input[type="radio"][value="${variantValue}"]`);

            if (variantInput && (variantInput.disabled || variantInput.classList.contains('disabled'))) {
                item.classList.add('disabled');
                item.classList.remove('available');
            } else if (variantInput) {
                item.classList.remove('disabled');
                item.classList.add('available');
            } else {
                item.classList.add('disabled');
                item.classList.remove('available');
            }
        });
    }

    // NUEVA FUNCIÓN: Actualizar disponibilidad de swatches de color basado en talla seleccionada
    function updateColorSwatchAvailability(selectedSize) {
        const colorSwatches = document.querySelectorAll('.swatch-color-item');
        
        console.log(`🎯 Actualizando swatches para talla: "${selectedSize}"`);
        console.log(`📊 Total swatches encontrados: ${colorSwatches.length}`);
        
        colorSwatches.forEach((swatch, index) => {
            const availableSizes = swatch.dataset.availableSizes;
            const productHandle = swatch.dataset.productHandle;
            const colorName = swatch.dataset.colorName;
            
            if (availableSizes && selectedSize) {
                const sizesArray = availableSizes.split(',').map(size => size.trim());
                
                if (sizesArray.includes(selectedSize)) {
                    // La talla está disponible en este color
                    swatch.classList.remove('swatch-unavailable');
                    swatch.style.pointerEvents = '';
                    console.log(`✅ ${colorName} (${productHandle}): Disponible - Tallas: [${availableSizes}]`);
                } else {
                    // La talla NO está disponible en este color
                    swatch.classList.add('swatch-unavailable');
                   // swatch.style.pointerEvents = 'none';
                    console.log(`❌ ${colorName} (${productHandle}): NO disponible - Tallas: [${availableSizes}]`);
                }
            }
        });
    }

    // NUEVA FUNCIÓN: Obtener la talla actualmente seleccionada
    function getCurrentSelectedSize() {
        // Método 1: Buscar input de talla seleccionado (por radio buttons)
        const sizeInputs = document.querySelectorAll('input[data-variant-input]');
        
        for (let input of sizeInputs) {
            if (input.checked) {
                // Determinar si es una talla (no color)
                const fieldset = input.closest('fieldset');
                const fieldsetHandle = fieldset ? fieldset.dataset.handle : '';
                const fieldsetName = fieldset ? fieldset.getAttribute('name') : '';
                
                if (fieldsetHandle && (fieldsetHandle.includes('size') || fieldsetHandle.includes('Size'))) {
                    return input.value;
                }
                
                if (fieldsetName && (fieldsetName.includes('size') || fieldsetName.includes('Size'))) {
                    return input.value;
                }
            }
        }
        
        // Método 2: Buscar por nombre del campo
        const sizeFieldsets = document.querySelectorAll('fieldset[name*="Size"], fieldset[name*="size"]');
        for (let fieldset of sizeFieldsets) {
            const checkedInput = fieldset.querySelector('input:checked');
            if (checkedInput) {
                return checkedInput.value;
            }
        }
        
        // Método 3: Buscar selectores específicos del tema
        const sizeSelectors = document.querySelectorAll('select[name*="Size"], select[name*="size"]');
        for (let select of sizeSelectors) {
            if (select.value) {
                return select.value;
            }
        }

        // Método 4: Buscar en elementos con clases específicas
        const sizeElements = document.querySelectorAll('.variant-input input[type="radio"]:checked');
        for (let element of sizeElements) {
            const parentWrapper = element.closest('.variant-wrapper');
            if (parentWrapper) {
                const label = parentWrapper.querySelector('.variant__label');
                if (label && label.textContent.toLowerCase().includes('size')) {
                    return element.value;
                }
            }
        }
        
        return null;
    }

    // NUEVA FUNCIÓN: Escuchar cambios en las variantes (incluyendo tallas)
    function initializeSwatchSync() {
        // Escuchar cambios en todos los inputs de variantes
        const variantInputs = document.querySelectorAll('input[data-variant-input]');
        
        variantInputs.forEach(input => {
            input.addEventListener('change', function() {
                // Pequeño delay para asegurar que el DOM se actualice
                setTimeout(() => {
                    const selectedSize = getCurrentSelectedSize();
                    if (selectedSize) {
                        updateColorSwatchAvailability(selectedSize);
                        console.log('Size selected:', selectedSize);
                    }
                }, 50);
            });
        });

        // Método alternativo: Escuchar cambios en todos los inputs de tipo radio
        const radioInputs = document.querySelectorAll('input[type="radio"]');
        radioInputs.forEach(input => {
            input.addEventListener('change', function() {
                setTimeout(() => {
                    const selectedSize = getCurrentSelectedSize();
                    if (selectedSize) {
                        updateColorSwatchAvailability(selectedSize);
                        console.log('Size selected via radio:', selectedSize);
                    }
                }, 50);
            });
        });

        // Escuchar cambios en selects también
        const selectInputs = document.querySelectorAll('select');
        selectInputs.forEach(select => {
            select.addEventListener('change', function() {
                setTimeout(() => {
                    const selectedSize = getCurrentSelectedSize();
                    if (selectedSize) {
                        updateColorSwatchAvailability(selectedSize);
                        console.log('Size selected via select:', selectedSize);
                    }
                }, 50);
            });
        });

        // Observar cambios en el DOM para elementos dinámicos
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'checked') { 
                    setTimeout(() => {
                        const selectedSize = getCurrentSelectedSize();
                        if (selectedSize) {
                            updateColorSwatchAvailability(selectedSize); 
                            console.log('Size selected via DOM change:', selectedSize);
                        }
                    }, 50);
                }
            });
        });

        // Observar cambios en inputs de variantes
        const variantContainer = document.querySelector('.product-single__meta, .product-form, .product-variants');
        if (variantContainer) {
            observer.observe(variantContainer, {
                attributes: true,
                subtree: true,
                attributeFilter: ['checked']
            });
        }

        // Inicializar el estado al cargar la página
        setTimeout(() => {
            const initialSize = getCurrentSelectedSize();
            if (initialSize) {
                updateColorSwatchAvailability(initialSize);
                console.log('Initial size:', initialSize);
            }
        }, 100);
    }


     // Listener para las opciones de waist
    document.querySelectorAll('.sub-list.waist li').forEach(function (item) {
        item.addEventListener('click', function () {
        // Remove 'active' class from all items
        document.querySelectorAll('.sub-list.waist li').forEach(i => i.classList.remove('active'));
        // Add 'active' class to the clicked item

        // Capturar el valor del item seleccionado
        const selectedValue = this.textContent.trim();
            
        // Cerrar el colapso automáticamente
        //const subList = this.closest('.sub-list');
        //subList.style.display = 'none';

        // Añadir o actualizar el span con el valor seleccionado
        let waistSelectedSpan = document.getElementById("waist-value-selected");
       
        waistSelectedSpan.textContent = ':  ' + selectedValue;


        this.classList.add('active');
        selectedWaist = this.getAttribute('data-waist');
        updateInseamOptions(); // Update inseam options based on selected waist
        selectVariant();
        });
    });

    // Listener para las opciones de inseam
    document.querySelectorAll('.sub-list.inseam li').forEach(function (item) {
        item.addEventListener('click', function () {
        // Remove 'active' class from all items
        document.querySelectorAll('.sub-list.inseam li').forEach(i => i.classList.remove('active'));
        // Add 'active' class to the clicked item

         // Capturar el valor del item seleccionado
         const selectedValue = this.textContent.trim();
            
         // Cerrar el colapso automáticamente
         //const subList = this.closest('.sub-list');
         //subList.style.display = 'none';
 
         // Añadir o actualizar el span con el valor seleccionado
        let inseamSelectedSpan = document.getElementById("inseam-value-selected");
        inseamSelectedSpan.textContent = ':  ' + selectedValue;

        this.classList.add('active');
        selectedInseam = this.getAttribute('data-inseam');
        selectVariant();
        });
    });

    // INICIALIZAR: Ejecutar cuando el DOM esté listo
    document.addEventListener('DOMContentLoaded', function() {
        initializeSwatchSync();
    });

    // FALLBACK: Si el DOMContentLoaded ya pasó
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeSwatchSync);
    } else {
        initializeSwatchSync();
    }




// DEBUG ESPECÍFICO PARA GRID-GALLERY-PRODUCT
function debugSwatchesInStackedLayout() {
    console.log('=== DEBUGGING SWATCHES IN STACKED LAYOUT ===');
    
    // 1. Verificar si estamos en stacked layout
    const isStacked = document.querySelector('.gallery_stacked_layout');
    console.log('🔍 Stacked Layout Detected:', !!isStacked);
    
    // 2. Verificar swatches encontrados
    const swatches = document.querySelectorAll('.swatch-color-item');
    console.log('🎨 Swatches encontrados:', swatches.length);
    
    // 3. Verificar size inputs
    const sizeInputs = document.querySelectorAll('input[data-variant-input]');
    console.log('📏 Size inputs encontrados:', sizeInputs.length);
    
    // 4. Intentar detectar talla actual
    const currentSize = getCurrentSelectedSize();
    console.log('👕 Talla actual detectada:', currentSize);
    
    // 5. Verificar fieldsets de talla
    const sizeFieldsets = document.querySelectorAll('fieldset[name*="Size"], fieldset[name*="size"]');
    console.log('📋 Size fieldsets encontrados:', sizeFieldsets.length);
    
    sizeFieldsets.forEach((fieldset, index) => {
        const checkedInput = fieldset.querySelector('input:checked');
        console.log(`   Fieldset ${index}: ${fieldset.getAttribute('name')} - Checked: ${checkedInput ? checkedInput.value : 'none'}`);
    });
    
    console.log('=== END DEBUG ===');
}

// Ejecutar debug después de que el layout se haya aplicado
if (document.querySelector('.gallery_stacked_layout')) {
    setTimeout(debugSwatchesInStackedLayout, 2000);
}




// RE-INICIALIZACIÓN PARA STACKED LAYOUT
function reinitializeSwatchesForStacked() {
    const isStacked = document.querySelector('.gallery_stacked_layout');
    
    if (isStacked) {
        console.log('🔄 Re-inicializando swatches para stacked layout...');
        
        // Reconfigurar event listeners con delay
        setTimeout(() => {
            // Remover listeners anteriores
            const oldInputs = document.querySelectorAll('input[data-variant-input]');
            oldInputs.forEach(input => {
                input.removeEventListener('change', handleSizeChange);
            });
            
            // Re-inicializar
            initializeSwatchSync();
            
            // Forzar actualización inicial
            const currentSize = getCurrentSelectedSize();
            if (currentSize) {
                updateColorSwatchAvailability(currentSize);
                console.log('✅ Swatches actualizados para stacked layout');
            }
        }, 1000);
    }
}

// Función para manejar cambios de talla
function handleSizeChange() {
    setTimeout(() => {
        const selectedSize = getCurrentSelectedSize();
        if (selectedSize) {
            updateColorSwatchAvailability(selectedSize);
            console.log('🎯 Size changed in stacked layout:', selectedSize);
        }
    }, 50);
}

// Ejecutar re-inicialización
reinitializeSwatchesForStacked();

  